import { BenchmarkTable } from "@/components/BenchmarkTable";
import { getBenchmarksForInsight } from "@/data/insightBenchmarks";

interface InsightBenchmarksProps {
  insightSlug: string;
}

export const InsightBenchmarks = ({ insightSlug }: InsightBenchmarksProps) => {
  const benchmarks = getBenchmarksForInsight(insightSlug);

  if (benchmarks.length === 0) {
    return null;
  }

  return (
    <section className="py-8 sm:py-10">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-foreground mb-6">
        Industry Benchmarks & Data
      </h2>
      <div className="space-y-6">
        {benchmarks.map((benchmark, index) => (
          <BenchmarkTable key={index} {...benchmark} />
        ))}
      </div>
    </section>
  );
};
